import CommercialMembershipPlanTable from "./pages/CommercialMembershipPlanTable";

const CommercialMembership: React.FC = () => {
   return (
      <div className="">
       <CommercialMembershipPlanTable />
      </div>
    );
};
export default CommercialMembership;
